module.exports = __webpack_public_path__ + "img/team.f2060391.jpg";